import { confirm } from 'owa-confirm-dialog';
/**
 * Show an error message dialog without cancel button
 * @param messageTitle
 * @param messageSubText
 */
export default function showErrorMessage(messageTitle, messageSubText) {
    return confirm(messageTitle, messageSubText, false, {
        hideCancelButton: true,
    });
}
//# sourceMappingURL=showErrorMessage.js.map